import { connect } from 'react-redux';
import type { FutureProps } from '@/pages/CompanyReport/components/Future';
import Future from '@/pages/CompanyReport/components/Future';
import { getFutureSelector } from '@/pages/CompanyReport/components/Future/redux/selectors';
import { areStatesEqualCompanySection } from '@/pages/CompanyReport/redux/selectors';

type StateProps = Omit<FutureProps, 'sectionNumber'>;
type ContainerProps = Partial<Pick<FutureProps, 'companyId' | 'sectionNumber'>>;

const mapStateToProps = (state, ownProps: ContainerProps): StateProps => {
  const future = getFutureSelector(state, ownProps);

  return {
    analystCount: future.analystCount,
    companyId: future.companyId,
    companyName: future.companyName,
    currencyISO: future.currencyISO,
    currencyUnit: future.currencyUnit,
    earningsGrowthAnnual: future.earningsGrowthAnnual,
    futureROE3Y: future.futureROE3Y,
    industryName: future.industryName,
    marketName: future.marketName,
    industryROE3Y: future.industryROE3Y,
    isFund: future.isFund,
    netIncomeGrowthAnnualIndustry: future.netIncomeGrowthAnnualIndustry,
    netIncomeGrowthAnnualMarket: future.netIncomeGrowthAnnualMarket,
    revenueGrowthAnnual: future.revenueGrowthAnnual,
    revenueGrowthAnnualIndustry: future.revenueGrowthAnnualIndustry,
    revenueGrowthAnnualMarket: future.revenueGrowthAnnualMarket,
    earningsGrowthAnnualFormatted: future.earningsGrowthAnnualFormatted,
    netIncomeGrowthAnnualIndustryFormatted:
      future.netIncomeGrowthAnnualIndustryFormatted,
    netIncomeGrowthAnnualMarketFormatted:
      future.netIncomeGrowthAnnualMarketFormatted,
    revenueGrowthAnnualFormatted: future.revenueGrowthAnnualFormatted,
    revenueGrowthAnnualIndustryFormatted:
      future.revenueGrowthAnnualIndustryFormatted,
    revenueGrowthAnnualMarketFormatted:
      future.revenueGrowthAnnualMarketFormatted,
    /**
     * Earnings and Revenue Growth Forecasts
     */
    cashflow: future.cashflow,
    cashflowMax: future.cashflowMax,
    cashflowMin: future.cashflowMin,
    dayZero: future.dayZero,
    earnings: future.earnings,
    earningsMax: future.earningsMax,
    earningsMin: future.earningsMin,
    freeCashflow: future.freeCashflow,
    freeCashflowMax: future.freeCashflowMax,
    freeCashflowMin: future.freeCashflowMin,
    revenue: future.revenue,
    revenueMax: future.revenueMax,
    revenueMin: future.revenueMin,
    cashflowAnalystsMap: future.cashflowAnalystsMap,
    earningsAnalystsMap: future.earningsAnalystsMap,
    freeCashflowAnalystsMap: future.freeCashflowAnalystsMap,
    revenueAnalystsMap: future.revenueAnalystsMap,
    /**
     * Earnings per Share Growth Forecasts
     */
    EPSMin: future.EPSMin,
    EPSMax: future.EPSMax,
    EPSAnalysts: future.EPSAnalysts,
    EPSAnalystConfirmation: future.EPSAnalystConfirmation,
    analystsEPSRangeMin: future.analystsEPSRangeMin,
    analystsEPSRangeMax: future.analystsEPSRangeMax,
    EPSDayZero: future.EPSDayZero,
    EPS: future.EPS,
    analystsPastEPSRangeLow: future.analystsPastEPSRangeLow,
    analystsPastEPSRangeHigh: future.analystsPastEPSRangeHigh,
    analystsFutureEPSRangeLow: future.analystsFutureEPSRangeLow,
    analystsFutureEPSRangeHigh: future.analystsFutureEPSRangeHigh,
  };
};

export default connect(mapStateToProps, null, null, {
  areStatesEqual: areStatesEqualCompanySection,
})(Future);
